
import React, { Component } from 'react';
import { Anchor, Box, Heading, Text } from 'grommet';

import BackLink from './BackLink';
import Page from './Page';
import TratDetail from '../components/TratDetail';
import ObjectDetail from './ObjectDetail';

class TratDetailPage extends Component {

    componentDidMount() {
        this.props.getTratDetail(this.props.requiredId);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.tratDetail.loading &&
            (this.props.tratDetail.id !== nextProps.requiredId)) {
            this.props.getTratDetail(nextProps.requiredId);
        }
    }

    getTitle() {
        return 'Biotické mapování tratí';
}

    render() {
        return (
            <Page>
                <Box direction="row">
                    <Heading level={1} color="titleColor">{this.getTitle()}</Heading>
                    <Box pad={{top: '64px', left: '16px'}} direction="row">
                        <Text size="small">(</Text>
                        <Anchor href={`#/link_bioticke_mapovani`} label="co je biotické mapování" />
                        <Text size="small">,&nbsp;</Text>
                        <Anchor href={`#/link_Odrudova_skladba`} label="co je odrůdová skladba" />
                        <Text size="small">)</Text>
                    </Box>
                </Box>

                <ObjectDetail objectDetail={this.props.tratDetail} >
                    <TratDetail
                        tratDetail={this.props.tratDetail}
                        setMapPoints={this.props.setMapPoints}
                    />
                </ObjectDetail>

                <BackLink link="/trate" title="Zpět na seznam tratí"/>
            </Page>
        );
    }
}

export default TratDetailPage;
